function scoreOf(code) {
    const value = code.likelihood;
    return typeof value === "number" && Number.isFinite(value) ? value : -1;
}
/** Returns a new array sorted by likelihood, highest first. Stable. */
export function sortIcdSuggestionsByLikelihood(codes) {
    return codes
        .map((code, index) => ({ code, index }))
        .sort((a, b) => scoreOf(b.code) - scoreOf(a.code) || a.index - b.index)
        .map((entry) => entry.code);
}
/** The single most likely code, or null for an empty list. */
export function mostLikelyIcdSuggestion(codes) {
    return sortIcdSuggestionsByLikelihood(codes)[0] ?? null;
}
//# sourceMappingURL=icd-likelihood.js.map